<template>
  <div class="container-fluid mt-5 page-padding margin_80_35">
    <div class="row pt-3">
      <div class="col-12 text-center faq-hero">
        <h1>How can we help you?</h1>
        <p class="faq-hero-sub">Browse a topic below, or use the search bar above.</p>
      </div>
    </div>

    <div class="row pt-4" v-if="categorylist.length > 0">
      <div class="col-sm-6 col-lg-4 col-xl-3 pb-4" v-for="category in categorylist" :key="category.Id">
        <router-link :to="'/faq/' + category.Id" class="faq-category-card">
          <div class="faq-category-icon">
            <i :class="category.Icon || 'bi bi-question-circle'"></i>
          </div>
          <h3 class="faq-category-title">{{ category.Title }}</h3>
          <div class="faq-category-children" v-if="category.ChildCategory && category.ChildCategory.length > 0">
            <span v-for="child in category.ChildCategory.slice(0, 3)" :key="child.Id">{{ child.Title }}</span>
            <span v-if="category.ChildCategory.length > 3">+{{ category.ChildCategory.length - 3 }} more</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="row pt-5" v-else-if="loaded">
      <div class="col-12 text-center py-5">
        <p>No FAQ categories are available right now.</p>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryService from '../services/category-service'

export default {
  name: 'FaqList',
  data() {
    return {
      categorylist: [],
      loaded: false
    }
  },
  mounted() {
    document.title = 'Circleram | FAQ'
    this.getCategory()
  },
  methods: {
    getCategory() {
      CategoryService.getcategoryList().then(response => {
        if (response.data.Status && response.data.Object) {
          this.categorylist = response.data.Object.categories.filter(function (item) { return item.ParentId === 0 })
        } else {
          this.categorylist = []
        }
        this.loaded = true
      }, (error) => {
        console.log(error)
        this.loaded = true
      })
    }
  }
}
</script>

<style scoped>
.faq-hero {
  margin-bottom: 20px;
}
.faq-hero-sub {
  color: #777;
  margin-bottom: 24px;
}
.faq-category-card {
  display: block;
  height: 100%;
  padding: 28px 20px;
  border: 1px solid #ededed;
  border-radius: 10px;
  text-align: center;
  text-decoration: none;
  color: inherit;
  transition: box-shadow .2s ease, transform .2s ease, border-color .2s ease;
}
.faq-category-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
  border-color: #ddd;
}
.faq-category-icon {
  font-size: 28px;
  margin-bottom: 12px;
  color: #5b4fff;
}
.faq-category-title {
  font-size: 17px;
  margin-bottom: 10px;
}
.faq-category-children {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}
.faq-category-children span {
  font-size: 12px;
  color: #888;
  background: #f4f4f6;
  border-radius: 12px;
  padding: 3px 10px;
}
</style>
